import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationPaddleIncompleteCheckoutIsCompleteGet = {
    path: "/paddle/incomplete-checkout/is-complete",
    method: ERouteHttpVerb.GET
};
export { routeLocationPaddleIncompleteCheckoutIsCompleteGet };
